/* eslint-disable no-unused-vars */
import { CLSTAG } from '@/utils/constant';
import { clstagStr } from '@/utils/util';
import { reportSgmEvent, SgmEventType } from '@/utils/sgm';
import React from 'react';
interface Props {
  isStoped: boolean;
  operatorIsSelf: boolean;
  disabled: boolean;
  vehicleName: string;
  userName: string;
}
const ResetGPS = (props: Props) => {
  const { isStoped, operatorIsSelf, disabled, vehicleName, userName } = props;
  let cls = '';
  const usable = isStoped && operatorIsSelf && !disabled;

  if (usable) {
    cls = 'item reset_gps';
  } else {
    cls = 'item location disabled';
  }

  const handleClick = (e: any) => {
    if (usable) {
      const url =
        '/app/cloudpoints?&vehiclename=' +
        vehicleName +
        '&username=' +
        userName;
      window.open(url);
      reportSgmEvent({
        type: SgmEventType.INFO,
        code: 'monitor_single_vehicle_entry',
        msg: {
          page: 'single_vehicle',
          vehicleName,
          action: 'enter_location_reset',
          trigger: 'click',
          requestId: null,
          result: 'opened',
        },
      });
    } else {
      reportSgmEvent({
        type: SgmEventType.WARN,
        code: 'monitor_single_vehicle_entry',
        msg: {
          page: 'single_vehicle',
          vehicleName,
          action: 'enter_location_reset',
          trigger: 'click',
          requestId: null,
          result: 'blocked',
          reason: 'button_unavailable',
        },
      });
    }
  };

  return (
    <li
      className={'item reset_gps'}
      onClick={handleClick}
      clstag={clstagStr(CLSTAG.ResetGps)}
    >
      {usable ? <div className='img_normal' /> : <div className='img_gray' />}

      <h3 className='operate_key'>定位重置</h3>
    </li>
  );
};
export default React.memo(ResetGPS);
